"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
const v4_1 = __importDefault(require("uuid/v4"));
/**
 * Omega script integration functions for use with Adobe Analytics.
 *
 * @see
 * {@link https://wiki.corp.adobe.com/display/OMEGA/Adobe+Data+Layer+Schema}.
 */
/* eslint-disable max-len */
/**
 * Initialize Omega Setup with digital data and tracking scripts in the
 * <code>HEAD</code> element in DOM.
 *
 * @param {string} script Optional tracking script for initializing omega
 * tracking object, default to tracking script for development environment
 * if not specified.
 *
 * @see {@link https://wiki.corp.adobe.com/display/OMEGA/Adobe+Data+Layer+Schema#AdobeDataLayerSchema-digitalData}
 * @private
 */
/* eslint-enable max-len */
function attachHeader(config) {
    const headElement = document.getElementsByTagName('head')[0];
    // attach analytics digitalData object, preserving an existing nonce if already present
    const nonce = global.digitalData && global.digitalData.nonce;
    global.digitalData = {
        event: [],
        nonce: nonce || v4_1.default(),
        page: {
            autoTrack: false,
            solution: {
                name: config.solution,
                version: config.version
            }
        },
        user: {}
    };
    // attach omega tracking script
    const trackingScriptElement = document.createElement('script');
    trackingScriptElement.setAttribute('src', config.script);
    trackingScriptElement.setAttribute('async', '');
    trackingScriptElement.setAttribute('crossorigin', '');
    headElement.appendChild(trackingScriptElement);
}
/**
 * Initialize the Omega scripts on the page/application as a singleton.
 *
 * @param {object} config A congfiguration object for the desired state.
 */
function initAnalytics(config) {
    if (!config) {
        return; // do nothing if no config
    }
    // do nothing if already intialized
    if (global.adobeMetrics.init.analytics) {
        return;
    }
    attachHeader(config);
    global.adobeMetrics.init.analytics = Object.assign({}, config);
}
exports.default = initAnalytics;
//# sourceMappingURL=AnalyticsScript.js.map